import React from 'react';
import {string} from 'prop-types';
import {Link} from 'react-router-dom';
import {Icon} from 'semantic-ui-react';

const ImagePlaceholder = props => {
  const icon = <Icon name='image' size='big' />;
  const className = 'ui image bordered db-image-placeholder';

  return props.href
    ? <Link to={props.href} className={className}>{icon}</Link>
    : <div className={className}>{icon}</div>;
};

ImagePlaceholder.propTypes = {
  href: string
};

export default ImagePlaceholder;



// WEBPACK FOOTER //
// ./public/components/images/ImagePlaceholder.jsx